module.exports = __webpack_public_path__ + "img/logo_en.2345a2f0.svg";